/* Writes only the Shopify cart item count to the parent domain.
   Shopify cart.js remains the cart. This file does not change cart UX. */
(function () {
  var COOKIE = 'wcs_cart_count';
  var MAX_AGE = 2592000;

  function write(count) {
    var n = parseInt(count, 10);
    if (!isFinite(n) || n < 0) return;
    document.cookie =
      COOKIE +
      '=' +
      n +
      '; Path=/; Domain=.westerncontainersales.com; Max-Age=' +
      MAX_AGE +
      '; SameSite=Lax; Secure';
  }

  function countFrom(event) {
    var data = event && event.cartData;
    if (data && typeof data.item_count === 'number') return data.item_count;
    return null;
  }

  function refreshFromCart() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js', {credentials: 'same-origin'})
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') write(cart.item_count);
      })
      .catch(function () {});
  }

  function bind() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var count = countFrom(event);
      if (count === null) refreshFromCart();
      else write(count);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
